import {Component, input} from '@angular/core';


@Component({
  selector: 'app-icons',
  standalone: true,
  imports: [],
  templateUrl: './icons.component.html',
  styleUrl: './icons.component.css'
})
export class IconsComponent {
  icon = input.required<string>();
  fill = input<string>('currentColor');
  width = input<string>('15px');
  svgClass = input<string>('inline-block');
}
